import { createApp } from 'vue';
import App from './App.vue';
import api from './ApiClient.js';
import './index.css';

const metaPrefix = 'film-';
const meta = Array.from(document.querySelectorAll(`meta[name^='${metaPrefix}']`)).reduce((rt, i) => ({ ...rt, [i.name.slice(metaPrefix.length)]: i.content }), {});
api.setBase(meta.api);

async function initializeApp() {
  try {
    const schema = await api.getComputedSchema();
    const app = createApp(App, { schema });
    app.mount('#app');
    //document.body.classList.add('dark-theme');
  } catch (error) {
    console.error('Error creating/mounting Vue app:', error);
    document.getElementById('app').innerHTML = `
      <div class="error">
        <h2>Error loading app</h2>
        <p>${error.message}</p>
        <pre>${error.stack}</pre>
      </div>
    `;
  }
}

initializeApp();
